import { service } from "@/api/service ";
import { toast } from "@/components/custom/Toast";
const state = {
  countries: [],
  errors: [],
};

const getters = {
  countriesGetter: (state) => state.countries,
};

const actions = {
  async getAllCountries({ commit }) {
    await service.getFun("/countries").then(
      (response) => {
        let result = response.data;
        commit("setCountries", result);
        console.log("countries", result);
      },
      (error) => {
        console.log(error);
      }
    );
  },

  async getCountryById({ commit }, payload) {
    await service.getFun(`/countries/${payload}`).then(
      (response) => {
        let result = response.data;
        commit("setCountries", result);
        console.log("countries", result);
      },
      (error) => {
        console.log(error);
      }
    );
  },

  async createCountry({ commit }, payload) {
    const res = await service.postFun(payload, "countries", null, {
      action: "getAllCountries",
    });
    if (res?.data) {
      commit("setAddCountry", res?.success);
      commit("setCountryErrors", []);
      toast("success");
    } else {
      commit("setCountryErrors", res);
    }
  },

  editCountry({ commit }, payload) {
    service
      .postFun(
        service.deleteNullValues(payload),
        `countries/${payload.id}`,
        null,
        {
          action: "getAllCountries",
        }
      )
      .then((result) => {
        commit("editCountry", result.success);
        toast(result.message);
      });
  },
  async deleteCountry({ commit }, payload) {
    const result = await service.deleteFun(`countries/${payload.payload}`, {
      action: "getAllCountries",
    });
    if (result) {
      commit("deleteCountryStatus", result.success);
      toast(result.message);
    }
  },
};

const mutations = {
  setCountries(state, countries) {
    state.countries = countries;
  },
  setAddCountry(state, countries) {
    state.countries = countries;
  },
  editCountry(state, countries) {
    state.countries = countries;
  },
  setCountryErrors(state, errors) {
    state.errors = errors;
  },
  deleteCountryStatus(state, Status) {
    state.deleteCountry = Status;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
